import { EntityBase } from "./EntityBase";
import { Pair } from "../obj/Pair";
import { User } from "./User";
import { State } from "./State";
import { FuelType } from "./FuelType";
import { Utility } from "./Utility";
import { Document } from "./Document";
import { UnitOfMeasure } from "./UnitOfMeasure";
import { LoadZone } from "./LoadZone";
import { RateClass } from "./RateClass";
import { Company } from "./Company";

export class Account extends EntityBase {
    isActive: boolean = true;
    autoGenerated: boolean = false;
    facilityName: string | null = null;
    accountNumber: string | null = null;
    serviceName: string | null = null;
    state: State | null = null;
    city: string | null = null;
    addressLine1: string | null = null;
    addressLine2: string | null = null;
    zip: string | null = null;
    fuelType: FuelType | null = null;
    utility: Utility | null = null;
    isCommunity: boolean = false;
    startingContractConfirmed: boolean = false;
    loadZone: LoadZone | null = null;
    rateClass: RateClass | null = null;
    unitOfMeasure: UnitOfMeasure | null = null;
    billImages: Document[] = [];
    keyName: string | null = null;
    user: User | null = null;
    company: Company | null = null;
    canBeUpdated: boolean | null = null;

    static accountIdent(account: Account): string {
        let ident = "";
        if (account.addressLine1 != null && account.addressLine1.length > 0) {
            ident = account.addressLine1;
        }
        if (account.accountNumber != null && account.accountNumber.length > 0) {
            ident = ident + ", " + account.accountNumber;
        }
        if (ident == "") {
            ident = "Default Account";
        }
        return ident;
    }
}